"use client";

import { Toaster as BaseToaster } from "@ubud-ui/react-ui-kit";

export function Toaster() {
  return <BaseToaster />;
}
